export { default } from './forEach.js'



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/each.js
// module id = 626
// module chunks = 67